import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40bc09a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-container" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "tips mt4" }
const _hoisted_8 = { class: "footer xag-page__footer" }
const _hoisted_9 = { class: "content" }

import AppHeader from '@/components/Header.vue'
import { getUserInvoiceList, removeInvocie } from '@/apis/invoice'
import { reactive, computed, ComputedRef, ref, Ref } from 'vue'
import { InvoiceItem, formatInvoiceItem } from '@/types/invoice'
import { useRouter, Router } from 'vue-router'
import {
  invoiceTypeColorMap,
  invoiceTypeTextMap,
  invoiceListStorageKey,
  invoiceEditItemStorageKey,
  selectInoviceStorageKey,
} from './definition'
import { Button, Tag, ActionSheet, Dialog } from 'vant'
import {
  showConfirmModal,
  showToastFail,
  showToastLoading,
  clearToast,
  showToastSuccess,
} from '@/utils/tools'

interface invoiceInfoType {
  invoiceTypeColor: string
  invoiceTypeText: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'select',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-unused-vars */
const $router: Router = useRouter()
const components = {
  AppHeader,
}
let currentItem: formatInvoiceItem
const actionSheetShow: Ref<boolean> = ref(false)
const invoiceList: Ref<formatInvoiceItem[]> = ref([])
async function deleteInovice() {
  actionSheetShow.value = false
  try {
    await showConfirmModal({
      title: '删除发票抬头？',
      message: '',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: '确定删除',
    })
    showToastLoading()
    await removeInvocie({ guid: currentItem.guid })
    showToastSuccess('删除成功')
    initInvoice(true)
  } catch (error) {
    if (error) {
      let message = (error && error.message) || '删除失败'
      showToastFail(message)
    } else {
      clearToast()
    }
  }
}
function editInvoice() {
  actionSheetShow.value = false
  sessionStorage.setItem(invoiceEditItemStorageKey, JSON.stringify(currentItem))
  $router.push({
    name: 'invoice-edit',
    query: {
      guid: currentItem.guid,
    },
  })
}
const actionOptions = [
  { name: '编辑', callback: editInvoice },
  { name: '删除', color: '#FF4D4F', callback: deleteInovice },
]
function showAction(item: formatInvoiceItem) {
  actionSheetShow.value = true
  currentItem = item
}
function addNewInvoice() {
  $router.push({
    name: 'invoice-edit',
  })
}
function confirmUseInvoiceItem(item: formatInvoiceItem) {
  sessionStorage.setItem(selectInoviceStorageKey, item.guid)
  $router.go(-1)
}
async function initInvoice(refresh = false) {
  // refresh为true时会不使用缓存
  let storageStr = sessionStorage.getItem(invoiceListStorageKey)
  let data
  if (storageStr && !refresh) {
    data = JSON.parse(storageStr)
  } else {
    try {
      showToastLoading()
      data = await getUserInvoiceList()
      sessionStorage.setItem(invoiceListStorageKey, JSON.stringify(data))
      clearToast()
    } catch (e) {
      showToastFail(e && e.message)
    }
  }
  if (data) {
    invoiceList.value = data.map((item: InvoiceItem) => ({
      ...item,
      typeColor: invoiceTypeColorMap.get(item.invoice_type),
      typeText: invoiceTypeTextMap.get(item.invoice_type),
    }))
    console.log('invoiceList.value', invoiceList.value)
  }
}
initInvoice()

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, { title: "发票抬头" }),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoiceList.value, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.guid,
          onClick: ($event: any) => (confirmUseInvoiceItem(item))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (item.default)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createVNode(_unref(Tag), { type: "success" }, {
                      default: _withCtx(() => [
                        _createTextVNode("默认")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                style: _normalizeStyle('color:' + item.typeColor)
              }, "[" + _toDisplayString(item.typeText) + "]", 5),
              _createElementVNode("div", null, _toDisplayString(item.header), 1)
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.taxpayer_no), 1)
          ]),
          _createVNode(_component_van_icon, {
            name: "ellipsis",
            size: "16",
            onClick: _withModifiers(($event: any) => (showAction(item)), ["stop"])
          }, null, 8, ["onClick"])
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createVNode(_unref(ActionSheet), {
      show: actionSheetShow.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((actionSheetShow).value = $event)),
      actions: actionOptions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    }, null, 8, ["show"]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(Button), {
          block: "",
          class: "confirm-button",
          onClick: addNewInvoice
        }, {
          default: _withCtx(() => [
            _createTextVNode("新增发票抬头")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})